export const ENV = {
    API_HOST: process.env.REACT_APP_KARAKTERBOOST_API_URL,
    OAUTH_AUTHORITY: process.env.REACT_APP_OAUTH_AUTHORITY,
    OAUTH_CLIENT: process.env.REACT_APP_OAUTH_CLIENT,
    OAUTH_SCOPE: process.env.REACT_APP_OAUTH_SCOPE,
    OAUTH_REDIRECT_URI: process.env.REACT_APP_OAUTH_REDIRECT_URI,
    OAUTH_SILENT_REDIRECT_URI: process.env.REACT_APP_OAUTH_SILENT_REDIRECT_URI,
}